
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"15","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 .87H1.25A1.25 1.25 0 000 2.12v11.25a1.25 1.25 0 001.25 1.25H15a1.25 1.25 0 001.25-1.25V2.12A1.25 1.25 0 0015 .87zm0 1.25v8.027l-2.037-2.035a1.25 1.25 0 00-1.768 0L9.633 9.674 6.195 6.237a1.25 1.25 0 00-1.767 0L1.25 9.415V2.12H15zM1.25 11.183L5.313 7.12l6.25 6.25H1.25v-2.187zM15 13.37h-1.67l-2.812-2.812 1.563-1.563L15 11.915v1.455zM9.375 5.558a.937.937 0 111.875 0 .937.937 0 01-1.875 0z","fill":"#424242"}})])
          )
        }
      }
    